import { MenuItem } from '@resultsgate-ui/shared'
export const navItems: MenuItem[] = [
    {
        name: 'menu.home',
        route: '/',
        routeExactMatch: true,
        icon: 'fas fa-tachometer-alt',
        roles: ['admin'],
    },
    {
        name: 'Objednávky',
        route: '/orders',
        icon: 'fas fa-file-invoice',
        roles: ['admin'],
    },
    {
        name: 'Zákazníci',
        route: '/customers',
        icon: 'fas fa-users',
        roles: ['admin'],
    },
    {
        name: 'Dotazníky',
        route: '/surveys',
        icon: 'fas fa-poll',
        roles: ['admin'],
    },
    {
        name: 'Vzorky',
        route: '/samples',
        icon: 'fas fa-dna',
        roles: ['admin'],
    },
    {
        name: 'Kategórie',
        route: '/categories',
        icon: 'fas fa-sitemap',
        roles: ['admin'],
    },
    {
        name: 'Analýzy',
        route: '/analyses',
        icon: 'fas fa-microscope',
        roles: ['admin'],
    },
    {
        name: 'Odberné metódy',
        route: '/samplingmethods',
        icon: 'fas fa-syringe',
        roles: ['admin'],
    },
    {
        name: 'Výsledky',
        route: '/results',
        icon: 'fas fa-database',
        roles: ['admin'],
    },
    {
        name: 'menu.calendar',
        route: '/calendar',
        icon: 'fas fa-calendar-alt',
    },
    {
        title: true,
        name: 'Kontakty',
    },
    {
        name: 'Slovgen.sk',
        url: 'https://slovgen.sk',
        icon: 'fas fa-home',
        variant: 'info',
        attributes: { target: '_blank', rel: 'noopener' },
    },
]
